import { Component, OnInit } from '@angular/core';
import { IToastr, toastrService } from '../../../services/ux/toastr.service';

@Component({
	selector: 'helius-toastr',
	templateUrl: 'toastr.component.html'
})

export class ToastrComponent implements OnInit  {
	notifications : Array<IToastr> = [];

	constructor(public toastr: toastrService){}

	ngOnInit(){
		this.listenForNotifications();
	}

	listenForNotifications() {
		this.toastr.newNotification.subscribe((notification) => {
			this.notifications.unshift(notification);

			setTimeout(() => {
				this.dismiss(notification);
			}, 3500);
		});
	}

	dismiss(notification: IToastr){
		let i: any;
		for (i in this.notifications) {
			if (this.notifications[i] === notification) {
				this.notifications.splice(i, 1);
			}
		}
	}
}
